import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { City } from './types/City';
import { APIV2_URL } from './constants';

interface GetCitiesNearbyQuery {
  // Mutually exclusive with lat/lng and countryCode
  query?: string;
  // Mutually exclusive with query/countryCode
  latitude?: number;
  // Mutually exclusive with query/countryCode
  longitude?: number;
  // Required for query or lat/lng
  radius?: number;
  // Mutually exclusive with lat/lng and query
  countryCode?: string;
  lang?: string;
  excludeQuery?: boolean;
  sameCountry?: boolean;
  minListings?: number;
  minPopulation?: number;
  maxPopulation?: number;
}

interface CitiesNearbyResponse {
  cities: City[];
  count: number;
}

export type GetCitiesNearbyCall = (
  data: GetCitiesNearbyQuery,
) => Promise<{ data: CitiesNearbyResponse }>;

export default (makeCall: MakeCall) => (query: GetCitiesNearbyQuery) =>
  makeCall<CitiesNearbyResponse>('GET', `${APIV2_URL}/geonames/cities`, {
    query,
  });
